module.exports = __webpack_public_path__ + "img/日志管理.13ef2df4.svg";